module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av395-4aa72ebcc2db301ead5ab7fd9cf727e7.jpg";